import { render, staticRenderFns } from "./RichTextDetails.vue?vue&type=template&id=30121e3a&scoped=true&"
import script from "./RichTextDetails.vue?vue&type=script&lang=js&"
export * from "./RichTextDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30121e3a",
  null
  
)

export default component.exports